// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"6b2d82bc","97":"d9b8408b","128":"cbef58f3","208":"a5f82921"}[chunkId] + ".chunk.css";
};